import { motion } from "framer-motion";
import PropTypes from "prop-types";
import Icon from "../../assets/btn-acept-Icon.svg";

export const AcceptButton = ({ onClick, isLoading, disabled, className }) => (
  <motion.button
    onClick={onClick}
    disabled={disabled}
    className={`transition-transform ${className || ""}`}
    whileHover={!disabled ? { scale: 1.12 } : {}}
    whileTap={!disabled ? { scale: 0.9 } : {}}
  >
    <motion.img
      src={Icon}
      alt="Aceptar"
      className="w-18 h-18"
      animate={
        isLoading
          ? { rotate: 360 } // Giro continuo si está cargando
          : { rotate: [0, -3, 3, 0] } // Oscilación normal si NO está cargando
      }
      transition={
        isLoading
          ? { repeat: Infinity, ease: "linear", duration: 1 }
          : { repeat: Infinity, duration: 4, ease: "easeInOut" }
      }
    />
  </motion.button>
);

AcceptButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
